import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface Props {
    sessions: number;
    onLater: () => void;
    onGoToReport: () => void;
}

export const PendingWarningModal: React.FC<Props> = ({ sessions, onLater, onGoToReport }) => {
    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
            <div className="bg-white rounded-3xl shadow-2xl w-full max-w-sm overflow-hidden animate-in zoom-in duration-200 p-6 text-center space-y-5 border-t-4 border-amber-500">
                <div className="w-16 h-16 bg-amber-100 text-amber-500 rounded-full flex items-center justify-center mx-auto shadow-inner">
                    <AlertTriangle size={32} />
                </div>

                <div>
                    <h2 className="text-xl font-bold text-gray-900">Report in Sospeso!</h2>
                    <p className="text-sm text-gray-600 mt-2">
                        Risultano turni lavorativi terminati per cui non hai ancora scritto il report.
                    </p>
                </div>

                {sessions > 0 && (
                    <div className="flex justify-center">
                        <span className="bg-slate-100 border border-slate-200 px-3 py-1.5 rounded-lg text-xs font-bold text-slate-600">
                            {sessions} Sessioni in attesa di Report
                        </span>
                    </div>
                )}

                <p className="text-xs text-amber-600 font-semibold bg-amber-50 p-3 rounded-xl border border-amber-100">
                    Ricordati di compilare e inviare il "Report" a fine giornata per rendicontare il tuo lavoro (le foto scattate verranno raggruppate in automatico!).
                </p>

                <div className="flex gap-3 pt-2">
                    <button
                        onClick={onLater}
                        className="flex-1 px-4 py-3.5 bg-gray-100 text-gray-700 rounded-xl font-bold hover:bg-gray-200 transition-colors"
                    >
                        Più tardi
                    </button>
                    <button
                        onClick={onGoToReport}
                        className="flex-[2] px-4 py-3.5 bg-amber-500 text-white rounded-xl font-bold hover:bg-amber-600 shadow-md transition-all active:scale-[0.98]"
                    >
                        Vai al Report
                    </button>
                </div>
            </div>
        </div>
    );
};
